import React from "react";
import { Text, Header } from "../../Components";

const CashLoanGeneralHeader = () => {
  return (
    <React.Fragment>
      <div className="cash-loan-header__wrapper">
        <div className="cash-loan-header__container">
          <div className="cash-loan-header__title">
            <Header>Wujudkan Banyak Hal Besar</Header>
          </div>
          <Text>
            Pembiayaan Tunai disediakan{" "}
            <b>khusus buat pelanggan setia Home Credit</b>. Bisa digunakan buat
            memulai usaha, biaya pendidikan/kesehatan, atau memenuhi kebutuhan
            yang mendesak.{" "}
            <b>Limit s.d. Rp100 juta, tenor fleksibel hingga 54 bulan</b>.
          </Text>
        </div>
      </div>
      <style jsx>{`
        .cash-loan-header__wrapper {
          display: flex;
          justify-content: center;
        }
        .cash-loan-header__container {
          max-width: 1032px;
          width: 100%;
          padding: 40px 0;
          margin: 0 16px;
        }
        .cash-loan-header__title {
          margin-bottom: 8px;
        }
        @media only screen and (max-width: 600px) {
          .cash-loan-header__container {
            padding: 32px 0;
            margin: 0 16px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default CashLoanGeneralHeader;
